






import Vue from 'vue';
import { Prop, Component } from 'vue-property-decorator';

@Component({
	componentId: 'C027',
	components: {},
	inheritAttrs: false
})
export default class StaticContent extends Vue {
	@Prop({ type: String, default: null })
	protected readonly text!: string | null;

	@Prop({ type: String, default: null })
	protected readonly contentBelongsToField!: string | null;

	private displayStateValue: any = {};

	get displayState(): any {
		return this.displayStateValue;
	}

	set displayState(value: any) {
		this.displayStateValue = value;
	}

	protected mounted() {
		if (this.contentBelongsToField) {
			let contentBelongsToFieldArray;
			let displayState = false;
			if (this.contentBelongsToField.includes(',')) {
				contentBelongsToFieldArray = this.contentBelongsToField.split(',');
			} else {
				contentBelongsToFieldArray = [this.contentBelongsToField];
			}
			contentBelongsToFieldArray.forEach(item => {
				let fields;
				if (item.includes('*')) {
					fields = document.querySelectorAll(`[name^="${item.replace('*', '')}"]`);
				} else {
					fields = document.getElementsByName(item);
				}
				if (fields.length > 0) {
					displayState = true;
				}
			});
			if (!displayState) {
				this.displayState = { display: 'none' };
			}
		}
	}
}
